<template lang="pug">

  //-
    - ENABLED
    -

  .newDutyItem(
    v-if="disabled === false"
    :class="{ 'selected': isSelected && isMultiSelectActive }"
    @click.stop.prevent="click(source)"
  )
    .item-content
      img(v-if="source.userImageIsValid" :src="source.userImage")

      .imgPlaceholder(v-else)
        | {{ (source.userName || source.userEmail)[0] }}

      span {{ source.userName || source.userEmail }}

    .selection-checkbox(v-if="isMultiSelectActive")
      v-checkbox(:input-value="isSelected" dense hide-details readonly color="primary")

  //-
    - DISABLED
    -

  .newDutyItem.newDutyItem--disabled(v-else)

    .item-content
      img(v-if="source.userImageIsValid" :src="source.userImage")

      .imgPlaceholder(v-else)
        | {{ (source.userName || source.userEmail)[0] }}

      span {{ source.userName || source.userEmail }}

</template>

<script>

export default {
  name: 'ScaleUserListItem',

  props: {
    click: {
      type: Function,
      default () {
        return function () { }
      },
    },
    source: {
      type: Object,
      default () {
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default () {
        return false
      },
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isMultiSelectActive: {
      type: Boolean,
      default: false
    }
  },
}

</script>

<style lang="scss" scoped>

.newDutyItem {
  transition-property: border-color, color, background-color, box-shadow;
  transition-duration: 200ms;

  cursor: pointer;

  width: 100%;
  padding: 5px 15px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.05));

  color: #333333;
  font-size: 14px;
  line-height: 14px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .item-content {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  .imgPlaceholder {
    background-color: rgba(0, 0, 0, 0.1);
    color: #444444;
    font-size: 10px;
    line-height: 30px;
    text-align: center;
  }

  .imgPlaceholder,
  img,
  span {
    display: inline-block;
    vertical-align: middle;
  }

  .imgPlaceholder,
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  span {
    padding-left: 12px;
  }

  &:hover {
    // border: 1px solid rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(0, 0, 139, 0.5);
    color: rgba(0, 0, 139, 0.7);
  }

  &.selected {
    background-color: #e3f2fd;
    border-color: #2196F3;
    box-shadow: 0 2px 5px rgba(33, 150, 243, 0.2);
    color: #1a237e;
  }

  &.newDutyItem--disabled {
    cursor: auto;

    color: #999999;
    background-color: #FFFFFF;

    &:hover {
      border: 1px solid rgba(0, 0, 0, 0.1);
      color: #333333;
    }
    &.selected {
      background-color: #FFFFFF;
      border-color: rgba(0, 0, 0, 0.1);
      box-shadow: none;
      color: #999999;
    }
  }

  .selection-checkbox {
    margin-left: 10px;
    .v-input--checkbox {
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 0;
      padding-bottom: 0;
      min-height: auto;
    }
  }
}
</style>
